import { render, staticRenderFns } from "./RiskControlStatistics.vue?vue&type=template&id=24918b32&scoped=true&"
import script from "./RiskControlStatistics.vue?vue&type=script&lang=js&"
export * from "./RiskControlStatistics.vue?vue&type=script&lang=js&"
import style0 from "./RiskControlStatistics.vue?vue&type=style&index=0&id=24918b32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24918b32",
  null
  
)

export default component.exports